/* istanbul ignore file */
import React, { forwardRef } from 'react'
import GoogleMap from './GoogleMap'

// eslint-disable-next-line
export default forwardRef(({ children, ...props }, ref) => (
  <GoogleMap ref={ref} {...props}>
    {children}
  </GoogleMap>
))
